// extracted by mini-css-extract-plugin
module.exports = {"arrowButton":"ArrowButton_arrowButton__2Ujgm","arrowButtonWhite":"ArrowButton_arrowButtonWhite__vEHmf","arrowButtonBlack":"ArrowButton_arrowButtonBlack__ow2B_"};